import { render } from "./calendarioOrganizacion.vue?vue&type=template&id=506d2a26"
import script from "./calendarioOrganizacion.vue?vue&type=script&lang=js"
export * from "./calendarioOrganizacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__